module.exports = __webpack_public_path__ + "credito.png?05cbda02576ab5d5a0b23f775504bc23";


//////////////////
// WEBPACK FOOTER
// ./src/assets/credito.png
// module id = 731
// module chunks = 0